/**
 * 模态框Iframe页面回调类型
 */
const ModalCallBackType = {
    None:'None',
    Connect:'Connect',
    /**
     * 提示消息
     */
    Message:'Message',
    /**
     * 刷新
     */
    Refresh:'Refresh',
    /**
     * 消息提示并刷新
     */
    MessageAndRefresh:'MessageAndRefresh',
};

export default ModalCallBackType;